module.exports = __webpack_public_path__ + "img/West-Ridge.91958399.jpeg";